export default __webpack_public_path__ + "static/media/logo-amwell.f0ad8242.png";